import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Minus = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.38 12.25H4.62C4.28 12.25 4 11.97 4 11.63C4 11.29 4.28 11 4.62 11H19.38C19.72 11 20 11.28 20 11.62C20 11.96 19.72 12.24 19.38 12.24V12.25Z" />
  </svg>
)

export default withDefaultStyles(Minus)
